import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

interface IParagraphDescriptionProps {
  text: string;
}

export const ParagraphDescription: React.FC<IParagraphDescriptionProps> = ({ text }) => (
  <UIText1 as="p">{text}</UIText1>
);
